import React, {Component} from 'react';
import './Footer.css';


export default class Footer extends Component {

render(){
    return(
      <footer className="footer">

          <span>JDButisbauch © 2019</span><br />

      </footer>
    )
  }
}